<template>
  <div
    v-if="favTournaments.length > 0 || favCategories.length > 0"
    class="bto-sb-widget bto-sb-widget-prematch bto-sb-widget-favourites-nav">
    <div class="bto-sb-widget-content">
      <div
        class="bto-sb-event-sports"
        :class="isUS ? 'bto-sb-scrolling-menu' : 'bto-sb-event-sports-slide'">
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-left">
          <a @click="sideScroll('left')"></a>
        </div>
        <ul ref="categoryList">
          <li v-for="tournament in favTournaments" :key="tournament.tournamentId">
            <span class="bto-sb-sports-icon" :class="getSportClass(tournament.sportId)"> </span>
            <router-link :to="openTournament(tournament)">
              {{ tournament.tournament }}
            </router-link>
            <span
              class="bto-sb-event-favorite bto-sb-event-favorite-add"
              @click.prevent="removeTournament(tournament)">
              <a href="javascript:void(0);" :title="t('W.RemFav')"></a>
            </span>
          </li>
          <li v-for="category in favCategories" :key="category.categoryId">
            <span class="bto-sb-sports-icon" :class="getSportClass(category.sportId)"> </span>
            <router-link :to="openCategory(category)">
              {{ category.category }}
            </router-link>
            <span
              class="bto-sb-event-favorite bto-sb-event-favorite-add"
              @click.prevent="removeCategory(category)">
              <a href="javascript:void(0);" :title="t('W.RemFav')"></a>
            </span>
          </li>
        </ul>
        <div class="bto-sb-event-more-sports bto-sb-event-more-sports-right">
          <a @click="sideScroll('right')"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../../store'
  import { urlFriendlyParam } from '@bto-services/utils';

  export default {
    name: 'FavoriteCategoriesWidget',
    data() {
      return {
        favCategoryMoveDistance: 16,
        isUS: APP_SETTINGS.settings.layout === 'US',
      };
    },
    computed: {
      favCategories() {
        return store.state.favoritesModule.categories || [];
      },
      favTournaments() {
        return store.state.favoritesModule.tournaments || [];
      },
    },
    methods: {
      openTournament(t) {
        const sport = urlFriendlyParam(t.sport);
        const tournament = urlFriendlyParam(t.tournament);
        const fixtureIds = `${t.tournamentId}`;
        const routeName = t.cType === 4 ? 'seoTournamentGroup' : 'seoTournament';
        return { name: routeName, params: { sport, tournament, fixtureIds } };
      },
      openCategory(c) {
        const sport = urlFriendlyParam(c.sport);
        const category = urlFriendlyParam(c.category);
        const categoryId = `${c.categoryId}`;
        const routeName = c.cType === 2 ? 'seoCategoryGroup' : 'seoCategory';
        return { name: routeName, params: { sport, category, categoryId } };
      },
      getSportClass(sportId) {
        return store.getters.getSportClass(sportId);
      },
      removeTournament(tournament) {
        this.$store.commit('removeFavoriteTournament', `${tournament.tournamentId}`);
      },
      removeCategory(category) {
        this.$store.commit('removeFavoriteCategory', `${category.categoryId}`);
      },
      /**
       *  horizontal scroll on click
       */
      sideScroll(direction) {
        let element = this.$refs.categoryList;
        let stepWidth = element.offsetWidth / 3;
        let directionStep = direction === 'right' ? element.scrollLeft + stepWidth : element.scrollLeft - stepWidth;
        this.scrollTo(element, directionStep, direction);
      },
      /**
       * Animate scrolling
       * @param element
       * @param to
       * @param direction
       */
      scrollTo(element, to, direction) {
        if (to < 0) {
          to = 0;
        }
        const maxScrollLeft = element.scrollWidth - element.offsetWidth;
        if (to >= maxScrollLeft) {
          to = maxScrollLeft;
        }
        let reqAnim = 0;
        const tick = () => {
          element.scrollLeft = direction === 'right' ?
            element.scrollLeft + this.favCategoryMoveDistance :
            element.scrollLeft - this.favCategoryMoveDistance;
          if ((direction === 'right' && element.scrollLeft < to) || (direction === 'left' && element.scrollLeft > to)) {
            reqAnim = requestAnimationFrame(tick);
          } else {
            cancelAnimationFrame(reqAnim);
          }
        };
        reqAnim = requestAnimationFrame(tick);
      },
    },
  }
</script>

<style scoped>
  div.bto-sb-event-more-sports {
    z-index: 100;
  }

  ul {
    padding-left: 30px;
    max-width: calc(100% - 30px);
  }
</style>